<template>
  <div class="w-5/6 lg:w-3/5 mx-auto">
    <p>
      <font face="标楷体" size="3"><br /></font>
    </p>
    <h1 class="text-3xl text-center">免责声明</h1>
    <p>
      <font face="标楷体" size="3"><br /></font>
    </p>
    <p>
      <font face="标楷体" size="3"
        >尊敬的患者、患者家属或患者的法定监护人、指定监护人、授权委托人：</font
      >
    </p>
    <p>
      <font face="标楷体" size="3"><br /></font>
    </p>
    <p>
      <font face="标楷体" size="3"
        >本公司（北京归源易生软件开发有限公司）所开发的“归源易生……”（以下简称“系统”）系中医医疗的辅助系统，旨在帮助医疗机构提升信息化建设水平，提升患者就医体验。就下述事项，本公司作出如下声明：</font
      >
    </p>
    <p>
      <font face="标楷体" size="3"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体" size="3"
        >1.&nbsp;<!--[endif]-->本公司不对医师开展服务中与专业性相关的内容的正确性进行保证。囿于医疗技术水平及医师个人经验，对病症的判别可能存在不同看法，本公司及本系统无法对其正确性与否作出判断或作出任何承诺及保证；</font
      >
    </p>
    <p>
      <font face="标楷体" size="3"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体" size="3"
        >2.&nbsp;<!--[endif]-->本公司承诺保护贵方的个人隐私信息，并以各种可行的技术手段或规章制度加以保护。但由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常运行之不可抗力而造成的个人资料泄露、丢失、被盗用或被窜改等本公司不承担责任；</font
      >
    </p>
    <p>
      <font face="标楷体" size="3"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体" size="3"
        >3.&nbsp;<!--[endif]-->本系统并非诊断平台，不具备诊疗的相应资格，处方系医师个人依据专业知识及经验做出的判断；</font
      >
    </p>
    <p>
      <font face="标楷体" size="3"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体" size="3"
        >4.&nbsp;<!--[endif]-->贵方选择某医疗机构接受医疗服务，即视为对该医疗机构本身及其人员的资质予以认可。我公司对该资质仅进行形式上的审查，但因行政审批存在滞后性等原因，我方无法对该医疗机构是否符合具备相应资质进行确认或保证；</font
      >
    </p>
    <p>
      <font face="标楷体" size="3"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体" size="3"
        >5.&nbsp;<!--[endif]-->本系统提供部分医疗辅助决策、医疗人工智能功能，但该功能仅根据中医经典理论及已经验证的药物配伍禁忌等作出辅助性提示，无法涵盖全部情况。诊疗结果及处方等内容仍由医师进行最终确认；</font
      >
    </p>
    <p>
      <font face="标楷体" size="3"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体" size="3"
        >6.&nbsp;<!--[endif]-->如贵方处方中包含毒麻药品或国家管制的其他药品的，医疗机构应按照相关法律法规进行二次核验等措施，对违反法律法规规定开具处方造成贵方人身损害的情况，本公司不应承担任何责任；</font
      >
    </p>
    <p>
      <font face="标楷体" size="3"><br /></font>
    </p>
    <p>
      <!--[if--><font face="标楷体" size="3"
        >7.&nbsp;<!--[endif]-->如贵方拟委托第三方通过本系统代为购药的，应签署《授权委托书》。贵方签署该授权委托书即视为贵方同意本系统将医师为贵方开具的处方传输至第三方医疗机构。</font
      >
    </p>
    <p>
      <font face="标楷体"><br /></font>
    </p>
  </div>
</template>
<script>
export default {
  name: "Disclaimer",
};
</script>
